import React, { useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, MenuItem } from '@mui/material';
import {NOTIFICATION_TYPE, showNotificationBar} from '../../../actions/error-pages/NotificationBarActions';
import { LoadingButton, TextButton } from '../../common/StyledButtons';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { SUBMISSION_TYPES_HUMAN_MAP } from '../../../constants/Statuses';
import { StyledAutocomplete, StyledMultilineTextField, StyledTextField } from '../../common/StyledTextField';
import { StyledDropDown } from '../../common/StyledDropDown';
import { SUBMISSION_TYPES, postSubmission } from '../../../actions/external/SubmissionActions';
import { getAllSites } from '../../../selectors/AdminSelectors';
import StyledSwitch from '../../common/StyledSwitch';
import { getUserId } from '../../../selectors/UserSelectors';
import { getAllSubmissionsForAdmin } from '../../../actions/internal/AdminActions';

const AdminAddRequestModal = ({ open, onClose }) => {

  const [ selectedSiteId, setSelectedSiteId ] = useState();
  const [ requestType, setRequestType ] = useState();
  const [ sendNotification, setSendNotification ] = useState(true);
  const [ values, setValues ] = useState({ title: '', description: ''})
  const [ errors, setErrors ] = useState([])

  const [ isLoading, setIsLoading ] = useState(false);

  const sites = getAllSites();

  const setFieldValue = (id, value) => {
    setValues({ ...values, [id]: value })
  }

  const clearForm = () => {
    setSelectedSiteId();
    setRequestType();
    setValues({});
    setErrors([]);
  }

  const handleClose = () => {
    clearForm();
    onClose();
  }

  const validateFields = () => {
    const errors = Object.keys(values).filter(key => !values[key] || values[key].trim() === '');
    if (!selectedSiteId) errors.push('business');
    if (!requestType) errors.push('requestType');
    return errors;
  }

  const getFormattedBusinessOptions = () => {
    if (!sites) return [];
    return sites.map(site => ({
      label: site.site_details.site_name,
      id: site.site_id
    }));
  }

  const handleAddRequest = async () => {
    try {
      // validate payload
      const errors = validateFields();
      if (errors.length > 0) {
        setErrors(errors)
        return;
      }
      setIsLoading(true);
      await postSubmission(
        requestType,
        { user_id: null, site_id: selectedSiteId },
        values,
        [],
        { send_submission_notification: sendNotification }
      )
      await getAllSubmissionsForAdmin(getUserId(), true, true);
      showNotificationBar(NOTIFICATION_TYPE.SUCCESS, "This request has been created successfully!");
      clearForm();
      onClose();
    } catch(ex) {
      console.error(ex);
      showNotificationBar(NOTIFICATION_TYPE.ERROR, "An error has occurred while canceling this request. If this continues to happen, please contact us.");
    } finally {
      setIsLoading(false)
    }
  }

  const handleBusinessSelected = (event, newValue) => {
    if (!newValue) {
      setSelectedSiteId();
      return;
    }
  
    const { id } = newValue;
    setSelectedSiteId(id);
  };

  // const { submission_status, submission_fields } = request || {}
  // const defaultFieldValues = submission_fields || {}
  // const isAdmin = isUserAdmin();

  return (
    <>
      <Dialog
          fullWidth
          open={open}
          maxWidth={'md'}
      >
          <DialogTitle>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Box>
                <h4 style={{ margin: 0, padding: 0 }}>Add Request</h4>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
              <StyledAutocomplete
                label="Business*"
                options={getFormattedBusinessOptions()}
                onChange={handleBusinessSelected}
                error={errors.includes('business')}
              />
              <StyledDropDown
                label="Request Type*"
                onChange={(e) => setRequestType(e.target.value)}
                error={errors.includes('requestType')}
              >
                {Object.keys(SUBMISSION_TYPES).map(key => (
                  <MenuItem key={key} value={key}>{SUBMISSION_TYPES_HUMAN_MAP[key]}</MenuItem>
                ))}
              </StyledDropDown>
              <StyledTextField
                label="Request Title*"
                onChange={(e) => setFieldValue('title', e.target.value)}
                error={errors.includes('title')}
              />
              <StyledMultilineTextField
                label="Description*"
                onChange={(e) => setFieldValue('description', e.target.value)}
                error={errors.includes('description')}
              />
            </Box>
          </DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '16px'}}>
              <Box>
                <StyledSwitch
                    title="Send Notification"
                    onChange={(e) => { setSendNotification(e.target.checked) }}
                    checked={sendNotification}
                />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                <TextButton sx={{ marginRight: '10px' }} onClick={handleClose} disabled={isLoading}>Cancel</TextButton>
                <LoadingButton onClick={handleAddRequest} isLoading={isLoading}>Save</LoadingButton>
              </Box>
            </Box>
      </Dialog>
    </>
  )
}

export default observer(withRouter(AdminAddRequestModal));
